import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/pc/modals/');

export default function AppModal() {
    const { useLang } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`appModal ${css.appModal}`}>
            <div className="app-img">
                <EFPic name={['modal-app.webp', 'modal-app.jpg']} className="fullImgs" alt={t('presale.product.modals.app_learn')} />
            </div>
            <div className="app-text">
                <p className="text-title">{t('presale.product.modals.app')}</p>
                <div className="text-main">
                    <p className="text-learn">{t('presale.product.modals.app_learn')}</p>
                    <p className="text-des">{t('presale.product.modals.app_des')}</p>
                </div>
            </div>
        </div>
    );
}
